import React, { useEffect } from "react";
import AdminNavBarMain from "./AdminNavBarMain";
import * as XLSX from "xlsx";
import { useState } from "react";
import FileSaver from "file-saver";
import Table from "react-bootstrap/Table";
import { useLocation, useNavigate } from "react-router-dom";
import axios from ".././axios-interceptor";
import {
  base_url,
  STATUS_PROCESSED,
  STATUS_CLOSED,
  LOAN_CURRENCY_TYPE_USD,
  LOAN_CURRENCY_TYPE_BHD,
  AUDITOR_ROLE,
} from "./../utilities";
import { Card } from "react-bootstrap";
import BusinesswithInvDetails from "./BusinesswithInvDetails";
import InvestorFullProfile from "./InvestorFullProfile";
import Skeleton from "react-loading-skeleton";
import { Form, Modal } from "react-bootstrap";
import { ThreeDots } from "react-loader-spinner";
import moment from "moment/moment";
import { toast } from "react-toastify";
import { decrypt } from "../utils";
import Cookies from 'js-cookie';

const SingleInvestorDetails = (props) => {
  const { state } = useLocation();
  Cookies.remove("investor_loan_id");
  const [investorData] = useState(state?.props);
  const prevLocation = state?.prevLocation
  Cookies.set("investor_loan_id", investorData?.investor_id, { expires: 7 });
  let loanslist = investorData?.invested_loans;
  let ltwo = props.loading;
  const [loading, setLoading] = useState(false);
  const [loandatafilter, setLoandataFilter] = useState([]);
  const navigate = useNavigate();
  const [loansListData, setLoansListData] = useState([]);
  const [loanslistSortedData, setLoanslistSortedData] = useState([]);
  const [firstValue, setFirstValue] = useState([]);
  const [secondValue, setSecondValue] = useState([]);
  const [thirdValue, setThirdValue] = useState([]);
  
  useEffect(() => {
    if (!Cookies.get("User_Accesstoken_Admin")) {
      navigate("/adminlogin");
    }
    setLoading(true);
    axios
      .post(base_url + "investor-master/get_investor_master")
      .then((allInvestors) => {
        if (
          Cookies.get("investor_loan_id") != undefined ||
          Cookies.get("investor_loan_id") != null
        ) {
          allInvestors.data.data.map((inv) => {
            if (inv.investor_id ==  Cookies.get("investor_loan_id")) {
              loanslist=inv?.invested_loans;
            }
          });
        }
        axios
          .post(base_url + "loan-trx/get_loan_trx_user", {
            user_id: Cookies.get("user_id"),
          })
          .then((res) => {
            let data = res.data.data;
            if (data !== "" || data !== undefined) {
              setLoading(false);
            }
            setLoandataFilter(data);
            setLoansListData(loanslist);
            setLoanslistSortedData(loanslist);
            setFirstValue(loanslist);
            setSecondValue(loanslist);
            setThirdValue(loanslist);
          });
      });
  }, []);

  const [sortOrder, setSortOrder] = useState({ column: null, direction: null });

  const [serviceRequests, setServiceRequests] = useState([]);
  const [defaultvalue, setDefaultValue] = useState(false);
  const [singleLoanDetails, setSingleLoanDetails] = useState([]);

  const [serviceRequestsfilter, setServiceRequestsFilter] = useState([]);

  const goToAdminInvestor = () => {
    navigate("/admininvestors");
  };

  function exportToExcel() {
    let sample_data_array = [];
    loanslistSortedData.forEach((elem) => {
      let xl_object = {
        "Ref No.": elem.loan_reference_number,
        "Total Invested":
          elem.admin_request_loan_currency + " " + elem.loan_amount,
        "Total Profit":
          elem.admin_request_loan_currency + " " + elem.profit_till_date,
      };
      sample_data_array.push(xl_object);
    });
    // create the data that you want to write to the excel file
    const data = sample_data_array;

    // create a worksheet and add the data to it
    const worksheet = XLSX.utils.json_to_sheet(data);

    // create a workbook and add the worksheet to it
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    // create the excel file and save it to the user's device
    const fileType =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    const fileExtension = ".xlsx";
    const fileName = "single_investor_loans_list.xlsx";
    const file = new Blob(
      [XLSX.write(workbook, { bookType: "xlsx", type: "array" })],
      { type: fileType }
    );
    FileSaver.saveAs(file, fileName);
  }
  const clearFilters = () => {
    setServiceRequestsFilter(serviceRequests);
    setDefaultValue(true);
    setLoansListData(loanslist);
    setLoanslistSortedData(loanslist);
    setFirstValue(loanslist);
    setSecondValue(loanslist);
    setThirdValue(loanslist);
  };
  const today = new Date().toISOString().substr(0, 10);

  const [initialValue, setInitialValue] = useState('')
  const [secondFilterValue, setSecondFilterValue] = useState('')
  const [thirdFilterValue, setThirdFilterValue] = useState('')

  const handleChangeInput = (e) => {
    const name = e.target.name;
    const value = e.target.value;

    if (name === "loanRefNo" && secondFilterValue ==='' && thirdFilterValue ==='') {
      setInitialValue("loanrefno")
      let f = firstValue.filter((item) => {
        if (value === item.loan_reference_number) {
          return item;
        }
        if (value == "All") {
          setInitialValue("")
          return item;
        }
      });
      setLoanslistSortedData(f);
      secondValue(f)
      thirdValue(f)
      
    }
    if (name === "loanRefNo" && secondFilterValue !=='' ) {
      let f = firstValue.filter((item) => {
        if (value === item.loan_reference_number) {
          return item;
        }
        if (value == "All") {
          setInitialValue("")
          return item;
        }
      });
      setLoanslistSortedData(f);
      thirdValue(f)
      
    }
    if (name === "totalinv" && initialValue ==='' && thirdFilterValue ==='') {
     setSecondFilterValue("totalinv")
     let startRange = value.split("-")[0];
     let endRange = value.split("-")[1];
     let f = secondValue.filter((item) => {
       let loanamount = Number(item.loan_amount);
       let initialAmount = Number(startRange);
       let finalAmount = Number(endRange);
       
       if (loanamount >= initialAmount && item.loan_amount <= finalAmount) {
         return item;
        }
        
        if (value === "All") {
          setSecondFilterValue("")
          return item;
        }
      });
      setLoanslistSortedData(f);
      setFirstValue(f)
      setThirdValue(f)
    }

    if (name === "totalprofit" && initialValue ==='' && secondFilterValue ==='') {
     setThirdFilterValue("totalprofit")
     let startRange = value.split("-")[0];
     let endRange = value.split("-")[1];
     let f = thirdValue.filter((item) => {
       let loanamount = Number(item.profit_till_date);
       let initialAmount = Number(startRange);
       let finalAmount = Number(endRange);
       
       if (
         loanamount >= initialAmount &&
         item.profit_till_date <= finalAmount
         ) {
           return item;
          }
          
          if (value === "All") {
            setThirdFilterValue("")
            return item;
        }
      });
      setLoanslistSortedData(f);
      setFirstValue(f)
      setSecondValue(f)
    }

    setDefaultValue(false);
  };

  const [investorFullProfModal, setInvestorFullProfModal] = useState(false);

  const [invPaymentData, setInvPaymentData] = useState([]);
  const handleInvPayment = (data) => {
    setInvPaymentData(data);
  };

  const uniqueRefNo = [
    ...new Set(firstValue?.map((d) => d.loan_reference_number)),
  ];

  const columns = [
    {
      title: "Ref No.",
      field: "loan_reference_number",
      sort: (a, b) =>
        a.loan_reference_number.localeCompare(b.loan_reference_number),
    },
    {
      title: "Total Invested",
      field: "final_loan_amount",
      sort: (a, b) => a.total_loans.localeCompare(b.total_loans),
    },
    {
      title: "Total Profit",
      field: "profit_till_date",
      sort: (a, b) => a.total_repaid.localeCompare(b.total_repaid),
    },
    {
      title: "Status",
      field: "status",
      sort: (a, b) => a.total_repaid.localeCompare(b.total_repaid),
    },
    {
      title: "Actions",
      field: "image",
      image: "./images/icons/double_arrow.svg",
      datatopass: "loan_reference_number",
    },
  ];
  const [invData, setInvData] = useState([]);
  const [hidecontent, setHideContent] = useState("d-block");
  const [shownextcontent, setShowNextContent] = useState("d-none");
  const handleHideContent = (props) => {
    setInvData(props);
    setHideContent("d-none");
    setShowNextContent("d-block");

    axios
      .post(base_url + "loan-trx/get_loan_details_loan_id", {
        loan_id: props.loan_id,
      })
      .then((res) => {
        let data = res.data.data;
        setSingleLoanDetails(data);
      });
  };
  // const handleSort = (sortFunc) => {
  //   const sortedData = [...loandatafilter].sort(sortFunc);
  //   setLoandataFilter(sortedData);
  // };

  const [InvFullprofileModal, setInvFullprofileModal] = useState(false);
  const handleSorttwo = (column) => {
    let direction = "asc";
    if (sortOrder.column === column && sortOrder.direction === "asc") {
      direction = "desc";
    }
    setSortOrder({ column, direction });

    const sortedData = [...loansListData].sort((a, b) => {
      const columnA = a[column];
      const columnB = b[column];
      if (typeof columnA === "string" && typeof columnB === "string") {
        return direction === "asc"
          ? columnA.localeCompare(columnB)
          : columnB.localeCompare(columnA);
      } else if (typeof columnA === "number" && typeof columnB === "number") {
        return direction === "asc" ? columnA - columnB : columnB - columnA;
      } else {
        return 0;
      }
    });
    setLoanslistSortedData(sortedData);
  };

  const InvModalData = () => {
    setInvFullprofileModal(true);
  };
  useEffect(() => {
    const handleBackButton = (event) => {
      event.preventDefault(); // Prevents default browser behavior
      if(prevLocation ==='/admininvestors'){
        navigate('/admininvestors')
      }
      navigate('/admininvestors'); // Navigate to the desired page

    };

    window.addEventListener('popstate', handleBackButton);
    
    return () => {
      window.removeEventListener('popstate', handleBackButton);
    };
  }, [navigate]);

  const [roleCode, setRoleeCode] = useState(() => {
    const storedRoleeCode = Cookies.get('role_code');
    return storedRoleeCode ? storedRoleeCode : '';
  });

  useEffect(()=>{
    if (roleCode) {
      try {
        const decryptedValueData = decrypt(roleCode);
        setRoleeCode(decryptedValueData);
      } catch (error) {
        console.error('Decryption error:', error);
      }
    }
  },[])

  return (
    <div>
      <AdminNavBarMain />

      <div className={` ${hidecontent} `}>
        <div
          className="row admin_body_main"
          style={{ backgroundColor: "transparent" }}
        >
          <div className="d-flex justify-content-between">
            <div className="col d-flex justify-content-between my-xxl-2  my-lg-1">
              <h5
                className="admin_serv mb-1"
                onClick={() => goToAdminInvestor(true)}
              >
                <img
                  src="./images/left_arrow.svg"
                  alt=""
                  className="indiv_loan_dtls"
                />
                &nbsp; Back
              </h5>
            </div>
          </div>

          <div className="container p-0">
            <Card className=" d-flex justify-content-between">
              <div className="row ">
                <div className="singlInvImage ">
                  <img src={investorData?.investor_image_url} alt="" />
                </div>
                <div className="col p-2 pe-5 ps-0">
                  <div className="d-flex">
                    <h4 className="inv_name_styl" onClick={InvModalData}>
                      {investorData?.investor_name}{" "}
                      <img src="./images/icons/rightarrow.svg" alt="" />{" "}
                    </h4>
                  </div>
                  <div className="singInvabout">{investorData?.about}</div>
                  <div className="d-flex gap-3 mt-2 ">
                    <div className="col-md-2 mb-3 mb-md-0 b_style_new ms-0 ms-md-1">
                      <span> Total committed</span>
                      <p className="p_style">
                        ${" "}
                        {Number(
                          investorData?.committed_principal
                        ).toLocaleString()}
                      </p>
                    </div>
                    <div className="col-md-2 mb-3 mb-md-0 n_style_new">
                      <span>Total Invested</span>
                      <p className="p_style">
                        $ {Number(investorData?.total_invested).toLocaleString()}
                      </p>
                    </div>
                    <div className="col-md-2 mb-3 mb-md-0 g_style_new">
                      <span>Total Available</span>
                      <p className="p_style">
                        ${" "}
                        {investorData?.total_available < 0 ? 0 : Number(investorData?.total_available).toLocaleString()}
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <InvestorFullProfile
                show={InvFullprofileModal}
                onHide={() => setInvFullprofileModal(false)}
                investorData={investorData}
              />
            </Card>
          </div>
          <div>
            <div className="row mb-2 mt-2 gap-3">
              <div className="col">
                <label htmlFor="country" className="form-label">
                  <p>Ref No.</p>
                </label>
                <select
                  id="loanRefNo"
                  className="form-select dropdn_select_cls  shadow-ben APNL_option_flds"
                  aria-label="form-select example"
                  name="loanRefNo"
                  autoComplete="off"
                  onChange={handleChangeInput}
                >
                  <option selected={defaultvalue}>All</option>
                  {uniqueRefNo.map((type) => {
                    return <option key={type}>{type}</option>;
                  })}
                </select>
              </div>

              <div className="col-lg">
                <label htmlFor="totalinv" className="form-label">
                  <p>Total Invested</p>
                </label>
                <select
                  className="form-select  dropdn_select_cls shadow-ben APNL_option_flds"
                  id="totalinv"
                  onChange={handleChangeInput}
                  name="totalinv"
                >
                  <option selected={defaultvalue}>All</option>
                  <option value="1000-5000">1000 - 5000</option>
                  <option value="5001-10000">5001 - 10000</option>
                  <option value="10001-50000">10001 - 50000</option>
                  <option value="50001-100000">50001 - 100000</option>
                  <option value="100001-150000">100001 - 150000</option>
                  <option value="150001-200000">150001 - 200000</option>
                  <option value="200001-250000">200001 - 250000</option>
                  <option value="250001-300000">250001 - 300000</option>
                  <option value="300001-350000">300001 - 350000</option>
                  <option value="350001-400000">350001 - 400000</option>
                  <option value="400001-450000">400001 - 450000</option>
                  <option value="450001-500000">450001 - 500000</option>
                  <option value="500001-750000">500001 - 750000</option>
                  <option value="750001-1000000">750001 - 1000000</option>
                </select>
              </div>
              <div className="col-lg-2">
                <label htmlFor="totalprofit" className="form-label">
                  <p>Total Profit</p>
                </label>
                <select
                  id="totalprofit"
                  className="form-select dropdn_select_cls  shadow-ben APNL_option_flds"
                  aria-label="form-select example"
                  name="totalprofit"
                  autoComplete="off"
                  onChange={handleChangeInput}
                >
                  <option selected={defaultvalue}>All</option>
                  <option value="1000-5000">1000 - 5000</option>
                  <option value="5001-10000">5001 - 10000</option>
                  <option value="10001-50000">10001 - 50000</option>
                  <option value="50001-100000">50001 - 100000</option>
                  <option value="100001-150000">100001 - 150000</option>
                  <option value="150001-200000">150001 - 200000</option>
                  <option value="200001-250000">200001 - 250000</option>
                  <option value="250001-300000">250001 - 300000</option>
                </select>
              </div>
              <div className=" col align-self-end">
                <button className="blue_btn" onClick={clearFilters}>
                  Clear All Filters
                </button>
              </div>
              <div className="col btn_style">
                <button className="blue_btn " onClick={exportToExcel} disabled={roleCode===AUDITOR_ROLE}>
                  Download XLS
                </button>
              </div>
            </div>
          </div>
        </div>

        <div className="col mt-3 singl_inv_tabl">
          <Table striped className="my_loan_table">
            <thead className="all_inv_table_head">
              <tr>
                {!loading && loanslistSortedData?.length === 0 ? (
                  <div className="d-flex justify-content-center fw-bolder fs-6">
                    No Investment Loans
                  </div>
                ) : (
                  columns.map((column) => {
                    return (
                      <>
                        <th
                          key={column.field}
                          onClick={() => handleSorttwo(column.field)}
                        >
                          {ltwo || loading ? (
                            <Skeleton width={100} height={15} />
                          ) : column.title !== "Actions" ? (
                            <div className="text-black table_data_header_styl">
                              {" "}
                              {column.title}&#9662;
                            </div>
                          ) : (
                            column.title
                          )}
                        </th>
                      </>
                    );
                  })
                )}
              </tr>
            </thead>
            <tbody>
              {loanslistSortedData?.map((interst, index) => {
                return (
                  <tr key={index} className="new_inv_interst_table">
                    <td>
                      {interst.loan_reference_number == undefined ? (
                        "-"
                      ) : (
                        <div className="">
                          {ltwo || loading ? (
                            <Skeleton width={100} height={15} />
                          ) : (
                            interst.loan_reference_number
                          )}
                        </div>
                      )}
                    </td>
                    <td>
                      {interst.final_loan_amount == undefined ? (
                        "-"
                      ) : ltwo || loading ? (
                        <Skeleton width={100} height={15} />
                      ) : (
                        <div>
                          $ {Number(interst.final_loan_amount).toLocaleString()}
                        </div>
                      )}
                    </td>
                    <td>
                      {interst.profit_till_date == undefined ? (
                        "-"
                      ) : ltwo || loading ? (
                        <Skeleton width={100} height={15} />
                      ) : (
                        <div>
                          $ {Number(interst.profit_till_date).toLocaleString()}
                        </div>
                      )}
                    </td>
                    <td>
                      {interst.status == undefined ? (
                        "-"
                      ) : ltwo || loading ? (
                        <Skeleton width={100} height={15} />
                      ) : (
                        <div
                          style={{
                            color:
                              interst.status === STATUS_PROCESSED
                                ? "#3d79f3"
                                : "green",
                          }}
                        >
                          {interst.status === STATUS_PROCESSED
                            ? "Processed"
                            : interst.status === STATUS_CLOSED
                            ? "Closed"
                            : ""}
                        </div>
                      )}
                    </td>
                    <td>
                      {ltwo || loading ? (
                        <Skeleton width={100} height={15} />
                      ) : (
                        <div className="gap-2">
                          <img
                            className="ps-2 pe-3 Cpointer "
                            src="./images/icons/double_arrow.svg"
                            style={{ height: "15px" }}
                            alt=""
                            onClick={() => handleHideContent(interst)}
                          />
                          {interst.status === STATUS_CLOSED ? (
                            <img
                              className="Cpointer"
                              src="./images/close_icon.svg"
                              alt=""
                            />
                          ) : (
                            <img
                              className=" Cpointer "
                              src="./images/icons/blue_eye.svg"
                              alt=""
                              onClick={() =>
                                handleInvPayment(
                                  interst,
                                  setInvestorFullProfModal(true)
                                )
                              }
                            />
                          )}
                        </div>
                      )}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </Table>

          <SingleInvestorPayments
            setLoading={setLoading}
            invPaymentData={invPaymentData}
            today={today}
            onHide={() => setInvestorFullProfModal(false)}
            handleChangeInput={handleChangeInput}
            investorFullProfModal={investorFullProfModal}
            loading={loading}
            roleCode={roleCode}
          />
        </div>
      </div>

      <div>
        <div className={`${shownextcontent} `}>
          <BusinesswithInvDetails
            hide={() => setHideContent("d-block")}
            showcontent={() => setShowNextContent("d-none")}
            loandetails={singleLoanDetails}
            invData={invData}
            investorData={investorData}
            roleCode={roleCode}
          />
        </div>
      </div>
    </div>
  );
};

export default SingleInvestorDetails;

export const SingleInvestorPayments = (props) => {
  let { investorFullProfModal, invPaymentData, today, loading, setLoading } =
    props;
  const [getTenureDates, setGetTenureDates] = useState([]);
  const [file, setUploadFile] = useState(null); //setUploadedUrl
  let loanID = invPaymentData.loan_id;
  const [filterDate, setFilterDate] = useState([]);
  const [paidDate, setpaidDate] = useState();
  const [comments, setComments] = useState("");
  const [isUpload, setUpload] = useState(false);
  const [url, setUploadedUrl] = useState(null);

  const handleChangePayment = (e) => {
    const { target } = e;
    const value = target.value;
    const name = target.name;

    if (name === "tenuredate") {
      document.getElementsByName("paidamount")[0].value = "";
      let f = getTenureDates.filter((item) => {
        let formatDate = moment(item.tenure_date).format("DD MMM YYYY");
        if (value === formatDate) {
          return item;
        }
      });
      if (value === "Select") {
        setFilterDate("");
      } else {
        setFilterDate(f[0]);
      }
    }
    if (name === "paiddate") {
      let datum = Date.parse(e.target.value);
      if (isNaN(datum)) {
        setpaidDate("");
        datum = "";
      } else {
        setpaidDate(datum);
      }
    }
  };
  const handleClosePrfModal = () => {
    props.onHide();
    setUploadFile(null);
    setUploadedUrl(null);
    setUpload(false);
    setFilterDate("");
  };

  const handleChange = (event) => {
    if (event.target.files[0].size < 5242880) {
      setUpload(true);
      setUploadFile(event.target.files[0].name);
      setUploadedUrl(event.target.files[0]);
    } else {
      toast.error("File size should be less than 5MB", {
        toastId: 7,
      });
    }
  };
  const handleChangeDownload = async () => {
    const fileUrl = URL.createObjectURL(url);
    window.open(fileUrl, "_blank");
  };
  const submitted = () => {
    const fd1 = new FormData();
    fd1.append("payment_schedule_id", filterDate?.payment_schedule_id);
    fd1.append("investor_id", invPaymentData.investor_id);
    fd1.append("tenure_date", filterDate?.tenure_date);
    fd1.append("tenure_amount", filterDate?.tenure_amount_investor_roi);
    fd1.append("paid_date", paidDate);
    fd1.append("paid_amount", filterDate?.tenure_amount_investor_roi);
    fd1.append("paid_currency", filterDate?.admin_request_loan_currency);
    fd1.append("received_via", selectedtype);
    fd1.append("document_url", url === "" ? null : url);
    fd1.append("comments", comments);
    fd1.append("admin_user_name", Cookies.get("admin_user_name"));
    fd1.append("admin_user_id", Cookies.get("admin_user_id"));
    if (url != null) {
      const fileName = file;
      const lastDotIndex = fileName.lastIndexOf(".");
      const fileExtension = fileName.substring(lastDotIndex + 1);
      fd1.append("file", url, fileExtension);
    }
    if (
      paidDate === undefined ||
      paidDate === "" ||
      paidDate === null ||
      selectedtype === undefined ||
      selectedtype === "" ||
      filterDate?.tenure_date === "" ||
      filterDate?.tenure_date === undefined ||
      filterDate?.tenure_date === "Select"
    ) {
      toast.error("Please fill out mandatory fields", {
        toastId: 107,
      });
    } else {
      setLoading(true);

      axios
        .post(base_url + "payments-to-investor/save_payment_to_investor", fd1, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((res) => {
          if (res.data.status == 200) {
            props.onHide();
            toast.success("Sucessfully Saved", {
              toastId: 20,
            });
            setLoading(false);
            setTimeout(() => {
              window.location.reload();
            }, 800);
          }
        });
    }
  };

  const handleChangeInputComments = (e) => {
    if (e.target.value === "" || e.target.value === undefined) {
      setComments("-");
    } else {
      setComments(e.target.value);
    }
  };

  useEffect(() => {
    if (loanID) {
      axios
        .post(base_url + "payment-schedules/get_tenure_dates_for_investor", {
          loan_id: loanID,
        })
        .then((res) => {
          let data = res.data.data;
          setGetTenureDates(data);
        });
    }
  }, [loanID]);

  const [selectedtype, setSelectedType] = useState();

  const radioButtonMethodRating = (e) => {
    setSelectedType(e.target.value);
  };
  const received_via_names = [
    "Wire Transfer",
    "Paid from Bank Account",
    "Cash",
    "Cheque",
    "Others",
  ];
  const [maxDate, setMaxDate] = useState('');
  useEffect(() => {
    const now = new Date();
    const today = now.toISOString().split('T')[0];
    const currentTime = now.getHours() * 3660 + now.getMinutes() * 60 + now.getSeconds();

    if (currentTime >= 0 && currentTime < 12 * 3660) {
      const tomorrow = new Date(now);
      tomorrow.setDate(now.getDate() + 1);
      const tomorrowDate = tomorrow.toISOString().split('T')[0];
      setMaxDate(tomorrowDate);
    } else {
      setMaxDate(today);
    }
  }, []);

  return (
    <Modal
      dialogClassName="modal-190w"
      aria-labelledby="example-custom-modal-styling-title"
      size="lg"
      backdrop="static"
      keyboard={false}
      centered
      show={investorFullProfModal}
      onHide={handleClosePrfModal}
    >
      <Modal.Header
        onHide={handleClosePrfModal}
        closeButton
        className="modal_title"
      >
        <Modal.Title id="example-custom-modal-styling-title">
          <div className=" ps-2 d-flex justify-content-between">
            <div className="heading_new_loan ">
              <h5 className="mb-0 me-5 pe-5">
                Payment to Investor{" "}
                <span className="fs-6 mb-0 sesame-color mb-3">
                  ( Loan Reference No: {invPaymentData.loan_reference_number} )
                </span>
              </h5>
            </div>
          </div>
        </Modal.Title>
      </Modal.Header>

      <Modal.Body
        className={`${loading ? "px-4" : "px-4 py-2"}`}
        style={{ height: "28rem" }}
      >
        <div className={loading ? "onClickApplyLoaderStyl" : ""}>
          <ThreeDots
            height="60"
            width="60"
            radius="9"
            color="#3d79f3"
            ariaLabel="three-dots-loading"
            wrapperStyle={{}}
            wrapperClassName=""
            visible={loading}
          />
        </div>
        <div className="row bg-white ">
          <div>
            <div className="row bg-white ">
              <div className="col">
                <h6>Record Payment</h6>
              </div>

              <div className="row">
                <div className="form-group col-lg-3 custm_input_styl">
                  <label htmlFor="tenuredate">
                    <p className="">
                      Tenure Date <span style={{ color: "red" }}>*</span>
                    </p>
                  </label>
                  <select
                    id="tenuredate"
                    name="tenuredate"
                    className="form-select  shadow-sm APNL_option_flds"
                    aria-label="form-select example"
                    onChange={handleChangePayment}
                  >
                    <option>Select</option>
                    {getTenureDates?.map((dates, index) => {
                      return (
                        <option key={index}>
                          {moment(dates.tenure_date).format("DD MMM YYYY")}
                        </option>
                      );
                    })}
                  </select>
                </div>
                <div className="col-lg-3">
                  <form className="form-group col m-2 mt-0 ms-4 custm_input_styl aksjdhf">
                    <label htmlFor="duepayment">
                      <p>Due Payment </p>
                    </label>
                    <input
                      disabled
                      type="text"
                      name="duepayment"
                      id="disabledTextInput"
                      className="form-control bg-white"
                      placeholder={
                        filterDate?.tenure_amount_investor_roi !== undefined
                          ? filterDate?.admin_request_loan_currency ===
                            LOAN_CURRENCY_TYPE_USD
                            ? "$ " + filterDate?.tenure_amount_investor_roi
                            : "BHD " + filterDate?.tenure_amount_investor_roi
                          : ""
                      }
                    />
                  </form>
                </div>
              </div>

              <div className="contianer p-0 d-flex">
                <div className="form-group me-3 custm_brdr">
                  <label htmlFor="paiddate">
                    <p>
                      Transferred Date <span style={{ color: "red" }}>*</span>
                    </p>
                  </label>
                  <input
                    name="paiddate"
                    id="paiddate"
                    type="date"
                    max={maxDate}
                    className="form-control rounded payemnt_details_BS_form_conrtl"
                    onChange={handleChangePayment}
                  />
                </div>

                <div className="col-lg-3">
                  <form className="form-group col m-2 mt-0 ms-3 custm_input_styl aksjdhf">
                    <label htmlFor="paidamount">
                      <p>Transferred Amount </p>
                    </label>
                    <input
                      disabled
                      type="number"
                      name="paidamount"
                      id="disabledTextInput"
                      className="form-control bg-white"
                      placeholder={
                        filterDate?.tenure_amount_investor_roi !== undefined
                          ? filterDate?.admin_request_loan_currency ===
                            LOAN_CURRENCY_TYPE_USD
                            ? "$ " + filterDate?.tenure_amount_investor_roi
                            : "BHD " + filterDate?.tenure_amount_investor_roi
                          : ""
                      }
                    />
                  </form>
                </div>
              </div>

              <div>
                <h3>
                  Transferred via{" "}
                  <span style={{ color: "red", fontSize: "1.2em" }}>*</span>
                </h3>
                <div className=" p-0 d-flex justify-content-between w-75">
                  {received_via_names?.map((element) => {
                    return (
                      <div key={element} className="admin_PD_radio_div row">
                        <label htmlFor={element}>
                          <input
                            className="PD_input_radio "
                            id={element}
                            type="radio"
                            name="radio"
                            value={element}
                            onClick={radioButtonMethodRating}
                          />
                          <span className="kyc_style_doc ps-2">{element}</span>
                        </label>
                      </div>
                    );
                  })}
                </div>
              </div>

              <div>
                <h3 className="mt-4">Comments</h3>
                <Form>
                  <Form.Group className=" " controlId="floatingTextarea">
                    <Form.Control
                      size="sm"
                      className="ANLtextarea custm_border_paymentdetails"
                      name="textarea"
                      as="textarea"
                      style={{ height: "50px", width: "95%" }}
                      rows={2}
                      placeholder="Please enter comments..."
                      onChange={handleChangeInputComments}
                    />
                  </Form.Group>
                </Form>
              </div>
              <div className="d-flex gap-5">
                <div className="attach_doc mt-3">
                  <label className="Cpointer padding_style">
                    <input type="file" onChange={(e) => handleChange(e)} />
                    <span className=" ps-3">Attach Document</span>
                  </label>
                </div>
                <div className="mt-3">
                  <div className="d-flex gap-5">
                    <div
                      className="upload_file_name"
                      data-bs-toggle="tooltip"
                      data-bs-placement="top"
                      title={file}
                    >
                      {file?.length > 25 ? file.slice(0, 25) : file}
                    </div>
                    <a style={{ display: "table-cell", cursor: "pointer" }}>
                      {isUpload == true && (
                        <i
                          className="fa-solid fa-eye text-primary fa-eye-font"
                          data-bs-toggle="tooltip"
                          data-bs-placement="top"
                          title="Click to view image"
                          onClick={(e) => handleChangeDownload()}
                        />
                      )}
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>

      <Modal.Footer className="d-flex  ps-3 pe-3">
        <div>
          <button
            className="btn btn_background mx-2 px-3 py-2"
            onClick={handleClosePrfModal}
          >
            Close
          </button>
          <button
            className="btn blue_btn mx-2 px-3 py-2"
            disabled={
              props.roleCode===AUDITOR_ROLE ||
              paidDate === undefined ||
              paidDate === "" ||
              paidDate === null ||
              selectedtype === undefined ||
              selectedtype === "" ||
              filterDate?.tenure_date === "" ||
              filterDate?.tenure_date === undefined ||
              filterDate?.tenure_date === "Select"
                ? true
                : false
            }
            onClick={submitted}
          >
            Save
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};
